import React from 'react';
import { Player, BigPlayButton } from 'video-react';
import Event from '../Event';
import hat from 'hat';
import ApiRequest from '../ApiRequest';

export default class PortfolioCarousel extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            contentType: null,
            showMore: {},
            filesMap: {},
            showMediaFooter: false,
            playingScroll: null,
            playing: null,
            startedPlaying: false
        };

        this.id = 'PortfolioCarousel_' + hat();

        this.handleScroll = this.handleScroll.bind(this);
    }

    componentDidMount() {
        if (!this.props.showAllContent) {
            if (this.props.contentType) {
                this.setState({ contentType: this.props.contentType });
            }
            Event.on('portfolioCarousel.contentType', (data) => {
                this.setState({ contentType: data.contentType ? data.contentType : null });
            }, this.id);
        } else {
            Event.on('portfolioCarousel.slide', (data) => {
                // Note: Whenever we update to React 16, we will be able to update reacstrap to 5 and should use reactstrap Carousel component instead of having to do the following:
                if (data && data.file && data.file.uid && this.state.filesMap[data.file.uid] !== undefined) {
                    if (window.$ && typeof window.$(`#${this.getId()}`).carousel === 'function') {
                        window.$(`#${this.getId()}`).carousel(this.state.filesMap[data.file.uid]);
                    }
                }
            }, this.id);
            this.setState({ filesMap: this.getFilesMap(this.props.user) });
        }

        Event.on('PortfolioCarousel.pauseVideos', (originVideo) => {
            if (this.state.playing && this.state.playing !== originVideo && this.refs[`player_${this.state.playing}`]) {
                this.refs[`player_${this.state.playing}`].pause();
            }
        }, this.id);
    }

    componentWillReceiveProps(props) {
        if (props.user) {
            this.setState({ filesMap: this.getFilesMap(props.user) });
        }
    }

    getFilesMap(user) {
        let filesMap = {};
        let filesMapIndex = 0;

        if (user.portfolio && user.portfolio.length > 0) {
            user.portfolio.map((item, index) => {
                filesMap[item.uid] = filesMapIndex++;
            });
        }

        if (user.files && user.files.length > 0) {
            user.files.filter(file => (file.video || file.sound)).map((item, index) => {
                filesMap[item.uid] = filesMapIndex++;
            });
        }

        return filesMap;
    }

    componentWillUnmount() {
        if (!this.props.showAllContent) {
            Event.off('portfolioCarousel.contentType', this.id);
        } else {
            Event.off('portfolioCarousel.slide', this.id);
        }
        Event.off('PortfolioCarousel.pauseVideos', this.id);
        window.removeEventListener("scroll", this.handleScroll);
    }

    showMore(e, name) {
        e.preventDefault();
        let showMore = this.state.showMore;
        showMore[name] = true;
        this.setState({ showMore });
    }

    credits() {
        return this.props.user.credits.map((item, index) => {
            return (
                <tr key={index}>
                    <td scope="row" style={index === 0 ? { borderTop: 0 } : {}}>
                        <p className="mb-0">
                            {item.role}
                            <br />
                            {item.production}
                        </p>
                    </td>
                    <td style={index === 0 ? { borderTop: 0 } : {}}>
                        <p className="mb-0">
                            {item.year}
                            <br />
                            {item.company}
                        </p>
                    </td>
                </tr>
            );
        });
    }

    handleScroll(e) {
        if (this.state.playing && Math.abs(this.state.playingScroll - window.scrollY) > 200) {
            if (this.refs[`player_${this.state.playing}`]) {
                this.refs[`player_${this.state.playing}`].pause();
            }
        }
    }

    getPortfolioCarouselItems(user) {
        if (this.state.contentType === 'credits') {
            return (
                <div style={{ backgroundColor: '#FFFFFF' }}>
                    <table className="table table-hover mb-0">
                        <tbody>
                            {this.credits()}
                        </tbody>
                    </table>
                    {this.props.user.credits.length > 5 && !this.state.showMore.credits ? (
                        <div className="text-center mt-3">
                            <a href="#" onClick={(e) => this.showMore(e, 'credits')}>
                                <button type="button" className="btn btn-secondary btn-sm">Show more credits</button>
                            </a>
                        </div>
                    ) : null}
                </div>
            );
        } else {
            let portfolio = [null, 'photos'].indexOf(this.state.contentType) !== -1 && user.portfolio && user.portfolio.length > 0 ? user.portfolio.map((item, index) => {
                return (
                    <div className={"carousel-item" + (index === 0 ? ' active' : '')} key={item.uid} item={item.uid}>
                        <img className="d-block img-fluid" src={this.props.getImageUrl(item.uid, 'portfolioraw', '')} alt="" onLoad={() => {
                            if (index === 0) {
                                //log first image view on first load.
                                this.logImageView(item.uid);
                            }
                        }} />
                    </div>
                );
            }) : [];

            let files = [null, 'mediaFiles'].indexOf(this.state.contentType) !== -1 && user.files && user.files.length > 0 ? user.files.filter(file => (file.video || file.sound)).map((item, index) => {
                index += portfolio.length;
                return item.realPath ? (
                    <div className={"carousel-item" + (index === 0 ? ' active' : '')} key={`2_${item.uid}_${index}`} item={item.uid} style={{ color: '#FFFFFF' }}>
                        <div className="carousel-video-container">
                            <Player
                                ref={`player_${item.uid}`}
                                poster={item.video && !item.sound ? null : '/assets/images/audio_background.png'}
                                src={`https://s3-eu-west-1.amazonaws.com/files.castcall.blue-compass.com/${item.realPath}`}
                                preload="none"
                                onPlay={() => {
                                    let playing = item.uid;
                                    Event.fire('PortfolioCarousel.pauseVideos', item.uid);
                                    
                                    if (!this.state.startedPlaying) {
                                        let request = new ApiRequest();
                                        request.post(`file/views/${item.uid}/${user.uid}` + (window.loggedInUser ? `/${window.loggedInUser.uid}` : ''));
                                    }

                                    this.setState({ showMediaFooter: true, playing, playingScroll: window.scrollY, startedPlaying: true }, () => {
                                        window.addEventListener("scroll", this.handleScroll);
                                    });
                                }}
                                onPause={() => {
                                    this.setState({ playing: null });
                                    window.removeEventListener("scroll", this.handleScroll);
                                }}
                                onEnded={() => {
                                    this.setState({ showMediaFooter: false, playing: null })
                                    window.removeEventListener("scroll", this.handleScroll);
                                }}
                            >
                                <BigPlayButton position="center" />
                            </Player>
                            {item.selfTape || item.attachedMedia ? <div className={'carousel-footer ' + (this.state.showMediaFooter ? 'hidden' : '')}>Media attached to the application.</div> : null}
                        </div>
                    </div>
                ) : null;
            }) : [];

            return portfolio.concat(files);
        }
    }

    getItemsCount() {
        if (this.state.contentType === 'credits') {
            return 1;
        } else {
            let count = 0;
            count += [null, 'photos'].indexOf(this.state.contentType) !== -1 && this.props.user.portfolio ? this.props.user.portfolio.length : 0;
            count += [null, 'mediaFiles'].indexOf(this.state.contentType) !== -1 && this.props.user.files ? this.props.user.files.filter(file => (file.video || file.sound)).length : 0;
            return count;
        }
    }

    getId() {
        return (this.props.idPrefix ? this.props.idPrefix : '') + "carouselControls_" + this.props.user.uid;
    }

    stopPlayers() {
        for (let key in this.refs) {
            if (this.refs.hasOwnProperty(key) && key.indexOf('player_') !== -1) {
                this.refs[key].load();
            }
        }
        this.setState({ showMediaFooter: false });
    }

    onCarouselMove(e) {
        e.preventDefault();
        this.stopPlayers();
        
        if (window.$) {
            if (window.$(`#${this.getId()} .carousel-inner .active`)[0]) {
                let currentItemUid = window.$(`#${this.getId()} .carousel-inner .active`)[0].getAttribute('item');
                let itemObject = this.props.user.portfolio.find((item) => (item.uid == currentItemUid));

                if (itemObject) {
                    // log image view when sliding through carousel
                    this.logImageView(itemObject.uid);
                }
            }
        }

        this.setState({startedPlaying: false});
    }

    logImageView(uid) {
        let request = new ApiRequest();
        request.post(`portfolio/views/${uid}/${this.props.user.uid}` + (window.loggedInUser ? `/${window.loggedInUser.uid}` : ''));
    }

    arrayChunk(array, chunkSize) {
        let R = [];
        for (let i = 0; i < array.length; i += chunkSize)
            R.push(array.slice(i, i + chunkSize));
        return R;
    }

    render() {
        return (
            <div id={this.getId()} className="carousel slide" data-ride="carousel" data-interval="500000">
                <div className={'carousel-inner portfolio-carousel' + (this.props.showAllContent ? ' no-print' : '')} role="listbox">
                    {this.getPortfolioCarouselItems(this.props.user)}
                </div>
                {this.getItemsCount() > 1 ? (
                    <div className="no-print">
                        <a className="carousel-control-prev" href={"#" + this.getId()} role="button" data-slide="prev" onClick={(e) => this.onCarouselMove(e)}>
                            <span className="carousel-control-prev-icon" aria-hidden="true"></span>
                            <span className="sr-only">Previous</span>
                        </a>
                        <a className="carousel-control-next" href={"#" + this.getId()} role="button" data-slide="next" onClick={(e) => this.onCarouselMove(e)}>
                            <span className="carousel-control-next-icon" aria-hidden="true"></span>
                            <span className="sr-only">Next</span>
                        </a>
                    </div>
                ) : null}
                {this.props.showAllContent ? (
                    <div className="portfolio-print-container only-print">
                        {this.props.user && this.props.user.portfolio ? this.arrayChunk(this.props.user.portfolio, 5).map((row, index) => {
                            return (
                                <div key={index}>
                                    {row.map(((item, index) => {
                                        return <img key={index} className="portfolio-print-img" src={this.props.getImageUrl(item.uid, 'portfolioraw', '')} />;
                                    }))}
                                </div>
                            );
                        }) : null}
                    </div>
                ) : null}
            </div>
        );
    }
}